<script>
import Layout from "@layouts/main-fluid";

export default {
  page: {
    title: "Loading page...",
    meta: [{ name: "description", content: "Loading page..." }]
  },
  components: { Layout }
};
</script>

<template>
  <Layout>
    <Transition appear>
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status"></div>
      </div>
    </Transition>
  </Layout>
</template>

<style lang="scss" module>
.loadingIcon {
  display: block;
  margin: 0 auto;

  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 3s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
}
</style>
